import Axios from "axios";
import Jsona from "jsona";

import packageJson from "../../../package.json";
import gitLastCommitJson from "../../.git-last-commit.json";
import { auth } from "../../shared/services/firebase";

const dataFormatter = new Jsona();

const transform = (data) =>
  !data || !data.data ? data : dataFormatter.deserialize(data);

const API = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "json",
  transformResponse: [transform],
});

const API_C2S = Axios.create({
  baseURL: process.env.REACT_APP_API_C2S_URL,
  responseType: "json",
});

const API_HADES = Axios.create({
  baseURL: process.env.REACT_APP_API_HADES_URL,
  responseType: "json",
  transformResponse: [transform],
});

API.interceptors.request.use(
  async (config) => {
    const token = await auth?.currentUser?.getIdToken();

    config.headers.common.Authorization = `Bearer ${token}`;

    const configWeb = {
      ...config,
      url: config.url.includes("?")
        ? `${config.url}&web=true`
        : `${config.url}?web=true`,
    };
    return configWeb;
  },
  function (error) {
    return Promise.reject(error);
  }
);

API.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (error?.response?.status === 401) {
      if (!originalRequest._retry) {
        originalRequest._retry = true;

        const idToken = await auth?.currentUser?.getIdToken(true);

        API.defaults.headers.common.Authorization = `Bearer ${idToken}`;

        return API(originalRequest);
      } else {
        auth.signOut();
      }
    }

    return Promise.reject(error);
  }
);

export function updateJWTToken(jwtToken) {
  API_C2S.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;
  API_HADES.defaults.headers.common.Authorization = `Bearer ${jwtToken}`;

  localStorage.setItem("jwt_token", jwtToken);
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (message) => {
    switch (message.data.source) {
      case "firebase-messaging-sw":
        API.post("/user_devices", {
          token: message.data.currentToken,
          os: navigator.userAgent,
          bundle_name: packageJson.name,
          bundle_short_version: gitLastCommitJson.tags[0],
          bundle_version: gitLastCommitJson.hash,
        });
        break;
      case "firebase-messaging-remove-token":
        API.delete(`/user_devices/${message.data.currentToken}`);
        break;
    }
  });
}

export { API, API_C2S, API_HADES };
